export default "__VITE_ASSET__54907ca4__"